module.exports = __webpack_public_path__ + "static/media/Media Settings.1c96f1f2.svg";